import { Scissors } from "lucide-react";
import { ProductCard } from "@/components/store/ProductCard";

export const CutChoppedSection = ({ products, onSeeAll }) => {
  const items = [...products.filter((p) => p.category_id === "combos"), ...products.filter((p) => p.category_id === "cut")];
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 mt-10 sm:mt-14" data-testid="cut-chopped-section">
      <div className="rounded-3xl bg-primary text-white p-5 sm:p-8 relative overflow-hidden grain">
        <div className="relative flex flex-wrap items-end justify-between gap-4 mb-5">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#d9e3b4] flex items-center gap-1.5"><Scissors className="w-3.5 h-3.5" /> Ready to cook</p>
            <h2 className="font-display text-3xl sm:text-4xl font-semibold mt-1 text-white">Combos, Cut & Chopped</h2>
            <p className="text-sm text-white/75 mt-1 max-w-md">Ready-to-cook packs like Sambhar and Undhiyu, plus vegetables washed, cut and packed fresh. Delivered next day.</p>
          </div>
          <button onClick={onSeeAll} className="h-10 px-5 rounded-full bg-white text-primary text-sm font-bold active:scale-95 transition-transform" data-testid="cut-see-all-btn">See all</button>
        </div>
        <div className="relative flex gap-3 sm:gap-5 overflow-x-auto no-scrollbar -mx-1 px-1 pb-1 text-[#3a3a3a]">
          {items.map((p, i) => (
            <div key={p.id} className="w-[46%] sm:w-[30%] lg:w-[23%] shrink-0"><ProductCard p={p} index={i} /></div>
          ))}
        </div>
      </div>
    </section>
  );
};
